import { Routes } from '@angular/router';
import { AppRoutesEnum } from '../@core/enum/appRoutes';
import { Permission } from '../@core/constants/permissionConstants';
import { PermissionGuard } from '../@core/guards/permission.guard';
import { dashboardRedirectGuard } from '../@core/guards/dashboard-redirect.guard';
import { dashboardRoleGuard } from '../@core/guards/dashboard-role.guard';

export const userRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard',
  },
  //   {
  //       path: AppRoutesEnum.DASHBOARD,
  //       loadComponent: () =>
  //           import('../layouts/dashboard/role-dashboard-wrapper.component').then(
  //               (m) => m.RoleDashboardWrapperComponent
  //           ),
  //       data: { permission: Permission.DASHBOARD },
  // canMatch: [PermissionGuard],
  //   },
  {
    path: AppRoutesEnum.DASHBOARD,
    loadComponent: () =>
      import('../layouts/dashboard/role-dashboard-wrapper.component').then(
        (m) => m.RoleDashboardWrapperComponent,
      ),
    canActivate: [dashboardRedirectGuard],
  },

  {
    path: `${AppRoutesEnum.HMO}/${AppRoutesEnum.DASHBOARD}`,
    loadComponent: () =>
      import(
        '../modules/dashboards/hmo-dashboard/hmo-dashboard.component'
      ).then((m) => m.HmoDashboardComponent),
    data: {
      roles: ['hmo'],
      permission: Permission.DASHBOARD,
    },
    canActivate: [dashboardRoleGuard],
    canMatch: [PermissionGuard],
  },
  {
    path: `${AppRoutesEnum.SUPER_ADMIN}/${AppRoutesEnum.DASHBOARD}`,
    loadComponent: () =>
      import(
        '../modules/dashboards/superadmin-dashboard/superadmin-dashboard.component'
      ).then((m) => m.SuperadminDashboardComponent),
    data: {
      roles: ['superadmin'],
      permission: Permission.DASHBOARD,
    },
    canActivate: [dashboardRoleGuard],
    canMatch: [PermissionGuard],
  },
  {
    path: `${AppRoutesEnum.INSUREE}/${AppRoutesEnum.DASHBOARD}`,
    loadComponent: () =>
      import(
        '../modules/dashboards/policy-dashboard/policy-dashboard.component'
      ).then((m) => m.PolicyDashboardComponent),
    data: {
      roles: ['insuree'],
      permission: Permission.DASHBOARD,
    },
    canActivate: [dashboardRoleGuard],
    canMatch: [PermissionGuard],
  },
  {
    path: `${AppRoutesEnum.PROVIDER}/${AppRoutesEnum.DASHBOARD}`,
    loadComponent: () =>
      import(
        '../modules/dashboards/provider-dashboard/provider-dashboard.component'
      ).then((m) => m.ProviderDashboardComponent),
    data: {
      roles: ['provider'],
      permission: Permission.DASHBOARD,
    },
    canActivate: [dashboardRoleGuard],
    canMatch: [PermissionGuard],
  },
  {
    path: `${AppRoutesEnum.NHIA}/${AppRoutesEnum.DASHBOARD}`,
    loadComponent: () =>
      import(
        '../modules/dashboards/nhia-dashboard/nhia-dashboard.component'
      ).then((m) => m.NhiaDashboardComponent),
    data: {
      roles: ['nhia'],
      permission: Permission.DASHBOARD,
    },
    canActivate: [dashboardRoleGuard],
    canMatch: [PermissionGuard],
  },
  {
    path: `${AppRoutesEnum.EMPLOYER}/${AppRoutesEnum.DASHBOARD}`,
    loadComponent: () =>
      import(
        '../modules/dashboards/employer-group-dashboard/employer-group-dashboard.component'
      ).then((m) => m.EmployerGroupDashboardComponent),
    data: {
      roles: ['payer', 'employer'],
      permission: Permission.DASHBOARD,
    },
    canActivate: [dashboardRoleGuard],
    canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.NOTIFICATION,
    loadComponent: () =>
      import(
        '../modules/notification-module/notification-module.component'
      ).then((m) => m.NotificationModuleComponent),
  },
  {
    path: AppRoutesEnum.FEEDBACK,
    loadChildren: () =>
      import('../modules/feedback/feedback.routes').then(
        (m) => m.feedbackRoutes,
      ),
    //           data: { permission: Permission.FEEDBACK },
    // canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.TIMELINE,
    loadComponent: () =>
      import(
        '../modules/policyholder-timeline/policyholder-timeline.component'
      ).then((m) => m.PolicyholderTimelineComponent),
  },
  {
    path: `${AppRoutesEnum.TIMELINE}/:id`,
    loadComponent: () =>
      import(
        '../modules/policyholder-timeline/policyholder-timeline.component'
      ).then((m) => m.PolicyholderTimelineComponent),
  },
  {
    path: `${AppRoutesEnum.PROVIDER_TIMELINE}/:id`,
    loadComponent: () =>
      import('../modules/provider-timeline/provider-timeline.component').then(
        (m) => m.ProviderTimelineComponent,
      ),
  },
  {
    path: AppRoutesEnum.SETTINGS,
    loadComponent: () =>
      import('../modules/settings/settings.component').then(
        (m) => m.SettingsComponent,
      ),
  },
  {
    path: AppRoutesEnum.CLAIM_MANAGEMENT,
    loadChildren: () =>
      import('../modules/claim-management/claims.routes').then(
        (m) => m.claimManagementRoutes,
      ),
    //       data: { permission: Permission.CLAIMS },
    // canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.HMO_MANAGEMENT,
    loadChildren: () =>
      import('../modules/hmo-management/hmo-management.routes').then(
        (m) => m.hmoRoutes,
      ),
    data: { permission: Permission.HMO_MANAGEMENT },
    canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.PROVIDERS_MANAGEMENT,
    loadChildren: () =>
      import('../modules/provider-management/provider-mgt.routes').then(
        (m) => m.providerManagementRoutes,
      ),
    data: { permission: Permission.PROVIDER_MANAGEMENT },
    canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.BENEFICIARY_MANAGEMENT,
    loadChildren: () =>
      import('../modules/beneficiary-management/beneficiary.routes').then(
        (m) => m.beneficiaryManagementRoutes,
      ),
    //       data: { permission: Permission.ENROLLES_MANAGEMENT },
    // canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.POLICY_MANAGEMENT,
    loadChildren: () =>
      import('../modules/policy-management/policy-management.route').then(
        (m) => m.PolicyRoutes,
      ),
    //       data: { permission: Permission.POLICY_MANAGEMENT },
    // canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.ACCREDITATION_MANAGEMENT,
    loadChildren: () =>
      import(
        '../modules/accreditation-management/accreditation-management.route'
      ).then((m) => m.accreditationRoutes),
    data: { permission: Permission.ACCREDITATION },
    canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.AUTHORIZATION,
    loadChildren: () =>
      import('../modules/authorization/authorization.route').then(
        (m) => m.authorizationRoutes,
      ),
  },
  {
    path: AppRoutesEnum.REFERRAL_MANAGEMENT,
    loadChildren: () =>
      import('../modules/referral-management/referral-mgt.routes').then(
        (m) => m.referralManagementRoutes,
      ),
    //       data: { permission: Permission.REFERRAL },
    // canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.MASTERS,
    loadChildren: () =>
      import('../modules/masters/masters.routes').then((m) => m.MastersRoutes),
    data: { permission: Permission.MASTER },
    canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.AUDIT_MANAGEMENT,
    loadChildren: () =>
      import('../modules/audit-management/audit.routes').then(
        (m) => m.auditManagementRoutes,
      ),
    data: { permission: Permission.AUDIT },
    canMatch: [PermissionGuard],
  },

  // {
  //     path: AppRoutesEnum.EMPTY,
  //     loadChildren: () =>
  //         import('../modules/super-admin/super-admin.routes').then(
  //             (m) => m.superAdminRoutes
  //         ),
  // },
  {
    path: AppRoutesEnum.REPORTS,
    loadChildren: () =>
      import('../modules/report/report.routes').then((m) => m.reportRoutes),
    //           data: { permission: Permission.REPORT },
    // canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.EMPLOYER_GROUP_MANAGEMENT,
    loadChildren: () =>
      import(
        '../modules/employer-group-management/employer-group-mgt.routes'
      ).then((m) => m.EmployerGroupManagementRoutes),
    data: { permission: Permission.EMPLOYER_GROUP_MANAGEMENT },
    canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.ENCOUNTER_MANAGEMENT,
    loadChildren: () =>
      import('../modules/encounter-management/encounter-mgt.routes').then(
        (m) => m.EncounterManagementRoutes,
      ),
    data: { permission: Permission.ENCOUNTER_MANAGEMENT },
    canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.ENCOUNTER_REFERRAL,
    loadComponent: () =>
      import(
        '../modules/encounters-referral/encounters-referral.component'
      ).then((m) => m.EncountersReferralComponent),
    //           data: { permission: Permission.ENCOUNTER_REFERRAL },
    // canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.SUPPORT_CENTER,
    loadComponent: () =>
      import('../modules/support-center/support-center.component').then(
        (m) => m.SupportCenterComponent,
      ),
    //           data: { permission: Permission.SUPPORT_CENTER },
    // canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.NEW_TICKET,
    loadComponent: () =>
      import('../modules/support-center/new-ticket/new-ticket.component').then(
        (m) => m.NewTicketComponent,
      ),
    data: { permission: Permission.SUPPORT_CENTER },
    canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.SUPPORT_VIEW,
    loadComponent: () =>
      import('../modules/support-center/support-view').then(
        (m) => m.SupportViewComponent,
      ),
    data: { permission: Permission.SUPPORT_CENTER },
    canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.REFERRAL_VIEW,
    loadComponent: () =>
      import('../modules/encounters-referral/referral-view').then(
        (m) => m.ReferralViewComponent,
      ),
    data: { permission: Permission.ENCOUNTER_REFERRAL },
    canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.SUBSCRIPTION_VIEW,
    loadComponent: () =>
      import(
        '../modules/super-admin/subscription-management/subscription-view'
      ).then((m) => m.SubscriptionViewComponent),
    data: { permission: Permission.SUBSCRIPTION_MANAGEMENT },
    canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.MY_CLAIM_VIEW,
    loadComponent: () =>
      import('../modules/claim-management/my-claim-view').then(
        (m) => m.MyClaimViewComponent,
      ),
    data: { permission: Permission.CLAIMS },
    canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.DEPENDANT_VIEW,
    loadComponent: () =>
      import(
        '../modules/beneficiary-management/dependent-enrollees/dependant-view'
      ).then((m) => m.DependentViewComponent),
    data: { permission: Permission.ENROLLES_MANAGEMENT },
    canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.MY_POLICY_VIEW,
    loadComponent: () =>
      import('../modules/policy-management/my-policy-view').then(
        (m) => m.MyPolicyViewComponent,
      ),
    data: { permission: Permission.POLICY_MANAGEMENT },
    canMatch: [PermissionGuard],
  },

  {
    path: AppRoutesEnum.USER_MANAGEMENT,
    loadComponent: () =>
      import(
        '../modules/super-admin/user-management/user-management.component'
      ).then((m) => m.UserManagementComponent),
    data: { permission: Permission.USER_MANAGEMENT },
    canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.ADD_USER_MANAGEMENT,
    loadComponent: () =>
      import(
        '../modules/super-admin/user-management/add-user-management/add-user-management.component'
      ).then((m) => m.AddUserManagementComponent),
    data: { permission: Permission.USER_MANAGEMENT },
    canMatch: [PermissionGuard],
  },
  {
    path: `${AppRoutesEnum.ADD_USER_MANAGEMENT}/:id`,
    loadComponent: () =>
      import(
        '../modules/super-admin/user-management/add-user-management/add-user-management.component'
      ).then((m) => m.AddUserManagementComponent),
    data: { permission: Permission.USER_MANAGEMENT },
    canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.ADD_AUDIT_ACTIVITY,
    loadComponent: () =>
      import(
        '../modules/super-admin/audit-activity/add-audit-activity/add-audit-activity.component'
      ).then((m) => m.AddAuditActivityComponent),
    data: { permission: Permission.AUDIT_ACTIVITY },
    canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.AUDIT_ACTIVITY,
    loadComponent: () =>
      import(
        '../modules/super-admin/audit-activity/audit-activity.component'
      ).then((m) => m.AuditActivityComponent),
    data: { permission: Permission.AUDIT_ACTIVITY },
    canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.PAYER,
    loadComponent: () =>
      import('../modules/super-admin/payer/payer.component').then(
        (m) => m.PayerComponent,
      ),
    data: { permission: Permission.HMO_MANAGEMENT },
    canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.ADD_PAYER_ACTIVITY,
    loadComponent: () =>
      import('../modules/super-admin/payer/add-payer/add-payer.component').then(
        (m) => m.AddPayerComponent,
      ),
    data: { permission: Permission.HMO_MANAGEMENT },
    canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.REPORTS_ANALYTICS,
    loadComponent: () =>
      import(
        '../modules/super-admin/reports-analytics/reports-analytics.component'
      ).then((m) => m.ReportsAnalyticsComponent),
    // data: { permission: Permission.REPORT_ANALYTICS },
    //   canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.ADD_REPORTS_ANALYTICS,
    loadComponent: () =>
      import(
        '../modules/super-admin/reports-analytics/add-reports-analytics/add-reports-analytics.component'
      ).then((m) => m.AddReportsAnalyticsComponent),
    data: { permission: Permission.REPORT_ANALYTICS },
    canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.ROLE_PERMISSION,
    loadComponent: () =>
      import(
        '../modules/super-admin/role-permission/role-permission.component'
      ).then((m) => m.RolePermissionComponent),
    // data: { permission: Permission.ROLE_MANAGEMENT },
    //   canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.PERMISSION_MANAGEMENT,
    loadComponent: () =>
      import(
        '../modules/super-admin/permission-management/permission-management.component'
      ).then((m) => m.PermissionManagementComponent),
    // data: { permission: Permission.PERMISSION_MANAGEMENT },
    //   canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.ADD_ROLE_FORM,
    loadComponent: () =>
      import(
        '../modules/super-admin/role-permission/add-role-permission/add-role-permission.component'
      ).then((m) => m.AddRolePermissionComponent),
    // data: { permission: Permission.ROLE_MANAGEMENT || Permission.PERMISSION_MANAGEMENT },
    //   canMatch: [PermissionGuard],
  },
  {
    path: `${AppRoutesEnum.ADD_ROLE_FORM}/:id`,
    loadComponent: () =>
      import(
        '../modules/super-admin/role-permission/add-role-permission/add-role-permission.component'
      ).then((m) => m.AddRolePermissionComponent),
    // data: { permission: Permission.ROLE_MANAGEMENT || Permission.PERMISSION_MANAGEMENT },
    //   canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.ADD_PERMISSION_FORM,
    loadComponent: () =>
      import(
        '../modules/super-admin/role-permission/add-role-permission/add-role-permission.component'
      ).then((m) => m.AddRolePermissionComponent),
    // data: { permission: Permission.ROLE_MANAGEMENT || Permission.PERMISSION_MANAGEMENT },
    //   canMatch: [PermissionGuard],
  },
  {
    path: `${AppRoutesEnum.ADD_PERMISSION_FORM}/:id`,
    loadComponent: () =>
      import(
        '../modules/super-admin/role-permission/add-role-permission/add-role-permission.component'
      ).then((m) => m.AddRolePermissionComponent),
    // data: { permission: Permission.ROLE_MANAGEMENT || Permission.PERMISSION_MANAGEMENT },
    //   canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.SUBSCRIPTION_MANAGEMENT,
    loadComponent: () =>
      import(
        '../modules/super-admin/subscription-management/subscription-management.component'
      ).then((m) => m.SubscriptionManagementComponent),
    data: { permission: Permission.SUBSCRIPTION_MANAGEMENT },
    canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.ADD_SUBSCRIPTION_MANAGEMENT,
    loadComponent: () =>
      import(
        '../modules/super-admin/subscription-management/add-subscription-management/add-subscription-management.component'
      ).then((m) => m.AddSubscriptionManagementComponent),
    data: { permission: Permission.SUBSCRIPTION_MANAGEMENT },
    canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.SYSTEM_CONFIGURATION,
    loadComponent: () =>
      import(
        '../modules/super-admin/system-configuration/system-configuration.component'
      ).then((m) => m.SystemConfigurationComponent),
    // data: { permission: Permission.SYSTEM_CONFIGURATION },
    //   canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.ADD_SYSTEM_CONFIGURATION,
    loadComponent: () =>
      import(
        '../modules/super-admin/system-configuration/add-system-configuration/add-system-configuration.component'
      ).then((m) => m.AddSystemConfigurationComponent),
    data: { permission: Permission.SYSTEM_CONFIGURATION },
    canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.BILLING_PAYMENT,
    loadComponent: () =>
      import(
        '../modules/super-admin/billing-payment/billing-payment.component'
      ).then((m) => m.BillingPaymentComponent),
    // data: { permission: Permission.BILLING_PAYMENT },
    //   canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.CAPITATION_BILLING_PAYMENT,
    loadComponent: () =>
      import(
        './../modules/capitation-billing-payment/capitation-billing-payment.component'
      ).then((m) => m.CapitationBillingPaymentComponent),
    data: { permission: Permission.BILLING_PAYMENT },
    canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.ADD_PREMIUM_CONTRIBUTION,
    loadComponent: () =>
      import(
        '../modules/super-admin/billing-payment/add-premium-contrubutions/add-premium-contrubutions.component'
      ).then((m) => m.AddPremiumContrubutionsComponent),
    data: { permission: Permission.BILLING_PAYMENT },
    canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.FULL_CLAIM_FINANCING_PROVIDER_PAYMENT,
    loadComponent: () =>
      import(
        '../modules/super-admin/billing-payment/claims-financing-provider-payments/claims-financing-provider-payments.component'
      ).then((m) => m.ClaimsFinancingProviderPaymentsComponent),
    data: { permission: Permission.BILLING_PAYMENT },
    canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.ADD_CLAIM_FINANCING_PROVIDER_PAYMENT,
    loadComponent: () =>
      import(
        '../modules/super-admin/billing-payment/claims-financing-provider-payments/add-claimsfinancing-provider-payments/add-claimsfinancing-provider-payments.component'
      ).then((m) => m.AddClaimsfinancingProviderPaymentsComponent),
    data: { permission: Permission.BILLING_PAYMENT },
    canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.FULL_REFUNDS_ADJUSTMENTS,
    loadComponent: () =>
      import(
        '../modules/super-admin/billing-payment/refund-adjustment/refund-adjustment.component'
      ).then((m) => m.RefundAdjustmentComponent),
    data: { permission: Permission.BILLING_PAYMENT },
    canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.VIEW_REFUND_ADJUSTMENT,
    loadComponent: () =>
      import(
        '../modules/super-admin/billing-payment/refund-adjustment/view-refund-adjustment/view-refund-adjustment.component'
      ).then((m) => m.ViewRefundAdjustmentComponent),
    data: { permission: Permission.BILLING_PAYMENT },
    canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.PAYMENT_GATEWAY,
    loadComponent: () =>
      import('../modules/payment-gateway/payment-gateway.component').then(
        (m) => m.PaymentGatewayComponent,
      ),
    // data: { permission: Permission.PAYMENT_GATEWAY },
    //   canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.FRAUD_COMPLIANCE,
    loadChildren: () =>
      import('../modules/fraud-compliance/fraud-compliance.routes').then(
        (m) => m.FraudMonitoringRoutes,
      ),
  },
  {
    path: AppRoutesEnum.SLA_MANAGEMENT,
    loadComponent: () =>
      import(
        '../modules/system-configuration/sla-management/sla-management.component'
      ).then((m) => m.SlaManagementComponent),
  },

  {
    path: AppRoutesEnum.BILLING_CREDITS,
    loadChildren: () =>
      import('../modules/billing-credits/billing-credits.routes').then(
        (m) => m.billingCreditsRoutes,
      ),
    // Add when the permission exists in the authentication payload.
    // data: { permission: Permission.BILLING_CREDITS },
    // canMatch: [PermissionGuard],
  },
  {
    path: AppRoutesEnum.CLAIMS_OVERSIGHT,
    loadChildren: () =>
      import('../modules/claims-oversight/claims-oversight.routes').then(
        (m) => m.claimsOversightRoutes,
      ),

    // Add when Claims Oversight permission is available.
    // data: { permission: Permission.CLAIMS_OVERSIGHT },
    // canMatch: [PermissionGuard],
  },
  {
    path: 'no-access',
    loadComponent: () =>
      import('../modules/no-access-page/no-access-page.component').then(
        (m) => m.NoAccessPageComponent,
      ),
    data: { type: 'no-access' },
  },
  {
    path: 'forbidden',
    loadComponent: () =>
      import('../modules/no-access-page/no-access-page.component').then(
        (m) => m.NoAccessPageComponent,
      ),
    data: { type: 'forbidden' },
  },

  {
    path: '**',
    loadChildren: () =>
      import('../modules/not-found-page/not-found-page.routes').then(
        (m) => m.notFoundPageRoutes,
      ),
  },
];
